(function () {
  'use strict';

  if (window.GPOAddonSystem) return;

  const EVT = {
    cartUpdate: 'cart:update',
    cartCount: 'cart:count:update',
    cartReload: 'cart:reload',
    cartDrawer: 'cart:drawer:render',
    cartError: 'cart:error',
  };

  function generateGroupId() {
    return 'gpo_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
  }

  function debounce(fn, ms) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), ms);
    };
  }

  async function fetchJSON(url, opts = {}) {
    const res = await fetch(url, {
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      ...opts,
    });
    const body = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(body.description || body.message || res.statusText);
    return body;
  }

  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    return r.json();
  }

  function formatMoney(cents, currencySymbol = '$') {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format || '{{amount}}');
    }
    return `${currencySymbol}${(cents / 100).toFixed(2)}`;
  }

  function getSection(el) {
    return el.closest('[id^="shopify-section-"], .shopify-section');
  }

  function collectAddons(section) {
    const results = [];

    section.querySelectorAll('[data-gpo-addon-block]').forEach(block => {
      const propertyName = block.dataset.propertyName;
      const isRequired = block.dataset.required === 'true';
      const isSingle = block.dataset.singleVariant === 'true';

      if (isSingle) {
        const cb = block.querySelector('[data-gpo-addon-checkbox]');
        if (!cb) return;

        if (!cb.checked) {
          if (isRequired) results.push({ selected: false, isRequired, propertyName, blockEl: block });
          return;
        }

        results.push({
          selected: true,
          isRequired,
          propertyName,
          variantId: parseInt(cb.dataset.variantId, 10),
          propertyValue: cb.dataset.propertyValue,
          price: parseInt(cb.dataset.variantPrice, 10) || 0,
          blockEl: block,
          currencySymbol: cb.dataset.currencySymbol,
        });

      } else {
        const activeBtn = block.querySelector('[data-gpo-variant-btn].gpo-variant-btn--active');

        if (!activeBtn) {
          if (isRequired) results.push({ selected: false, isRequired, propertyName, blockEl: block });
          return;
        }

        results.push({
          selected: true,
          isRequired,
          propertyName,
          variantId: parseInt(activeBtn.dataset.variantId, 10),
          propertyValue: activeBtn.dataset.propertyValue,
          price: parseInt(activeBtn.dataset.variantPrice, 10) || 0,
          blockEl: block,
        });
      }
    });

    return results;
  }

  function validateAddons(addons, section) {
    section.querySelectorAll('[data-gpo-validation]').forEach(el => (el.hidden = true));
    section.querySelectorAll('.gpo-addon-block--error').forEach(el =>
      el.classList.remove('gpo-addon-block--error'));

    let valid = true;
    let scrolled = false;

    addons.forEach(addon => {
      if (!addon.isRequired || addon.selected) return;
      valid = false;
      if (!addon.blockEl) return;

      addon.blockEl.classList.add('gpo-addon-block--error');
      const msg = addon.blockEl.querySelector('[data-gpo-validation]');
      if (msg) msg.hidden = false;

      const acc = addon.blockEl.querySelector('[data-gpo-addon-accordion]');
      if (acc) acc.open = true;

      if (!scrolled) {
        addon.blockEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        scrolled = true;
      }
    });

    return valid;
  }

  function buildPayload(mainVariantId, mainQty, addons, groupId) {
    const groupProps = { _gpo_product_group: groupId, _has_gpo: 'true' };

    const mainAddonProps = {};
    addons.filter(a => a.selected).forEach(a => {
      mainAddonProps[a.propertyName] = a.propertyValue;
    });

    return {
      items: [
        ...addons.filter(a => a.selected).map(a => ({
          id: a.variantId,
          quantity: mainQty,
          properties: { [a.propertyName]: a.propertyValue, ...groupProps, _is_addon: 'true' },
        })),
        {
          id: mainVariantId,
          quantity: mainQty,
          properties: { ...mainAddonProps, ...groupProps, _is_main: 'true' },
        },
      ],
    };
  }

  function fireCartEvents(cart) {
    let resource = cart;

    const detail = {
      resource,
      cartData: cart,
      actionAfterATC: 'drawer',
      source: 'product-form',
      data: { itemCount: cart.item_count },
    };

    document.dispatchEvent(new CustomEvent(EVT.cartUpdate, { detail }));
    document.dispatchEvent(new CustomEvent(EVT.cartCount, { detail: { item_count: cart.item_count, total_price: cart.total_price } }));
    document.dispatchEvent(new CustomEvent(EVT.cartDrawer, { detail }));
    document.dispatchEvent(new CustomEvent(EVT.cartReload, { detail }));
  }

  function refreshTotals(section) {
    const addons = collectAddons(section);
    const total = addons.filter(a => a.selected).reduce((s, a) => s + a.price, 0);
    const blocks = section.querySelectorAll('[data-gpo-addon-block]');
    if (!blocks.length) return;

    let header = section.querySelector('[data-gpo-header]');
    if (!header) {
      header = document.createElement('p');
      header.setAttribute('data-gpo-header', '');
      header.className = 'gpo-addons-header';
      blocks[0].before(header);
    }
    header.textContent = total
      ? 'Add-ons (+ ' + formatMoney(total,addons[0].currencySymbol) + ')'
      : 'Add-ons';

    let footer = section.querySelector('[data-gpo-footer]');
    if (!footer) {
      footer = document.createElement('p');
      footer.setAttribute('data-gpo-footer', '');
      footer.className = 'gpo-addons-footer';
      blocks[blocks.length - 1].after(footer);
    }
    if (total) {
      footer.hidden = false;
      footer.innerHTML =
        'Selections will add <strong class="gpo-footer-amount">' +
        formatMoney(total,addons[0].currencySymbol) +
        '</strong> to the price';
    } else {
      footer.hidden = true;
    }
  }

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    btn.disabled = loading;
    btn.setAttribute('aria-busy', loading ? 'true' : 'false');
    const spinner = btn.querySelector('.hdt-loading__spinner');
    if (spinner) spinner.hidden = !loading;
  }

  function showMessage(section, text, type = 'error') {
    let bar = section.querySelector('[data-gpo-msg]');
    if (!bar) {
      bar = document.createElement('p');
      bar.setAttribute('data-gpo-msg', '');
      bar.setAttribute('role', 'alert');
      const first = section.querySelector('[data-gpo-addon-block]');
      if (first) first.before(bar);
    }
    bar.className = 'gpo-msg gpo-msg--' + type;
    bar.textContent = text;
    bar.hidden = false;
    clearTimeout(bar._t);
    bar._t = setTimeout(() => { bar.hidden = true; }, 5000);
  }

  const _submitting = new WeakSet();

  function handleFormSubmit(event, form, section) {
    if (_submitting.has(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const variantInput = form.querySelector('input[name="id"]');
    const mainVariantId = variantInput ? parseInt(variantInput.value, 10) : 0;

    if (!mainVariantId || isNaN(mainVariantId)) {
      _submitting.add(form);
      try { form.requestSubmit && form.requestSubmit(); } catch (_) { }
      setTimeout(() => _submitting.delete(form), 100);
      return;
    }

    const qtyInput = form.querySelector('input[name="quantity"]');
    const mainQty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    const addons = collectAddons(section);

    if (!validateAddons(addons, section)) return;

    const submitBtn = form.querySelector('button[name="add"], button[type="submit"]');
    _submitting.add(form);
    setButtonLoading(submitBtn, true);

    const groupId = generateGroupId();
    const payload = buildPayload(mainVariantId, mainQty, addons, groupId);

    fetchJSON('/cart/add.js', { method: 'POST', body: JSON.stringify(payload) })
      .then(addResult => fetchCart().then(cart => ({ cart, addResult })))
      .then(({ cart, addResult }) => {
        fireCartEvents(cart);
        window.location.href = '/cart';
      })
      .catch(err => {
        showMessage(section, err.message || 'Could not add to cart. Please try again.', 'error');
        form.dispatchEvent(new CustomEvent(EVT.cartError, {
          bubbles: true,
          detail: { sourceId: form.id, data: { message: err.message } },
        }));
      })
      .finally(() => {
        setButtonLoading(submitBtn, false);
        _submitting.delete(form);
      });
  }

  const CartSync = {
    _syncGuard: false,

    _buildGroups(cart) {
      const groups = {};
      (cart.items || []).forEach((item, idx) => {
        const props = item.properties || {};
        const groupId = props._gpo_product_group;
        if (!groupId) return;
        if (!groups[groupId]) groups[groupId] = { main: null, addons: [] };
        const entry = { item, line: idx + 1, qty: item.quantity };
        if (props._is_main === 'true') groups[groupId].main = entry;
        else if (props._is_addon === 'true') groups[groupId].addons.push(entry);
      });
      return groups;
    },

    async _removeLines(lines) {
      if (!lines.length) return;
      const updates = {};
      lines.forEach(n => updates[`${n}`] = 0);
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates }),
      }).then(r => r.json());
    },

    async syncOrphans() {
      if (this._syncGuard) return;
      this._syncGuard = true;
      try {
        const cart = await fetchCart();
        const groups = this._buildGroups(cart);
        const lines = [];

        Object.values(groups).forEach(g => {
          if (!g.main && g.addons.length) g.addons.forEach(a => {
            lines.push(a.item.id);
          })
        });

        if (!lines.length) return;
        await this._removeLines(lines);
        const updated = await fetchCart();
        document.dispatchEvent(new CustomEvent(EVT.cartCount, { detail: { item_count: updated.item_count, total_price: updated.total_price } }));
        document.dispatchEvent(new CustomEvent(EVT.cartDrawer, { detail: { resource: updated, cartData: updated } }));
      } catch (_) {
      } finally {
        setTimeout(() => { this._syncGuard = false; }, 2000);
      }
    },

    async syncQuantities() {
      const cart = await fetchCart();
      const groups = this._buildGroups(cart);
      const updates = {};
      let needed = false;

      Object.values(groups).forEach(g => {
        if (!g.main) return;
        g.addons.forEach(a => {
          if (a.qty !== g.main.qty) { updates[a.line] = g.main.qty; needed = true; }
        });
      });

      if (!needed) return;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates }),
      });
      fireCartEvents(await fetchCart());
    },
  };

  function handleVariantBtnClick(btn, block) {
    const wasActive = btn.classList.contains('gpo-variant-btn--active');

    block.querySelectorAll('[data-gpo-variant-btn]').forEach(b => {
      b.classList.remove('gpo-variant-btn--active');
      b.setAttribute('aria-pressed', 'false');
    });

    const priceEl = block.querySelector('[data-gpo-selected-price]');

    if (wasActive) {
      if (priceEl) priceEl.textContent = '';
    } else {
      btn.classList.add('gpo-variant-btn--active');
      btn.setAttribute('aria-pressed', 'true');
      if (priceEl) {
        priceEl.textContent = '(+ ' + formatMoney(parseInt(btn.dataset.variantPrice, 10) || 0,btn.dataset.currencySymbol) + ')';
      }
    }

    block.classList.remove('gpo-addon-block--error');
    const msg = block.querySelector('[data-gpo-validation]');
    if (msg) msg.hidden = true;

    const section = getSection(block);
    if (section) refreshTotals(section);
  }

  function handleSingleCheckboxChange(cb, block) {
    const acc = block.querySelector('[data-gpo-addon-accordion]');
    if (acc && cb.checked) acc.open = true;

    const section = getSection(block);
    if (section) refreshTotals(section);
  }

  function initFormInterceptor() {
    document.addEventListener('submit', function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute('action') !== '/cart/add') return;

      const section = getSection(form);
      if (!section || !section.querySelector('[data-gpo-addon-block]')) return;

      handleFormSubmit(event, form, section);
    }, true);
  }

  function initVariantBtnListeners() {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-gpo-variant-btn]');
      if (!btn || btn.disabled) return;
      const block = btn.closest('[data-gpo-addon-block]');
      if (block) handleVariantBtnClick(btn, block);
    });
  }

  function initCheckboxListeners() {
    document.addEventListener('change', function (e) {
      const cb = e.target.closest('[data-gpo-addon-checkbox]');
      if (!cb) return;
      const block = cb.closest('[data-gpo-addon-block]');
      if (block) handleSingleCheckboxChange(cb, block);
    });
  }

  const debouncedOrphanSync = debounce(() => CartSync.syncOrphans().catch(() => { }), 1500);

  function initCartEventListeners() {
    [EVT.cartUpdate, EVT.cartDrawer, EVT.cartReload].forEach(name => {
      document.addEventListener(name, debouncedOrphanSync);
    });
  }

  const debouncedQtySync = debounce(() => CartSync.syncQuantities().catch(() => { }), 700);

  function initQuantityWatcher() {
    document.addEventListener('change', function (e) {
      if (e.target.closest('[will-change-cart]')) debouncedQtySync();
    });
  }

  function initTotals() {
    const sections = new Set();
    document.querySelectorAll('[data-gpo-addon-block]').forEach(b => {
      const s = getSection(b);
      if (s) sections.add(s);
    });
    sections.forEach(s => refreshTotals(s));
  }

  function initCartPageSync() {
    if (window.location.pathname === '/cart' ||
      window.location.pathname.startsWith('/cart/')) {
      CartSync.syncOrphans().catch(() => { });
    }
  }

  window.GPOAddonSystem = {
    generateGroupId,
    formatMoney,
    collectAddons,
    buildPayload,
    CartSync,
    refresh: initTotals,
  };

  function boot() {
    initFormInterceptor();
    initVariantBtnListeners();
    initCheckboxListeners();
    initCartEventListeners();
    initQuantityWatcher();
    initTotals();
    initCartPageSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();